import { useState } from 'react';
// import { pdfjs, Document, Page } from 'react-pdf';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/TextLayer.css';

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.js',
//   import.meta.url,
// ).toString();


// const options = {
//     cMapUrl: '/cmaps/',
//     standardFontDataUrl: '/standard_fonts/',
// };

export default function PDFViewer({source, vista, active}) {

    // const [numPages, setNumPages] = useState();
    // const [scale, setScale] = useState(1.5);
    //
    // function onDocumentLoadSuccess({ numPages }) {
    //     setNumPages(numPages);
    // }

    return (
        <div className={`pane pdf ${active ? 'active' : ''}`}>
            {/* <Document file={source} onLoadSuccess={onDocumentLoadSuccess} options={options} className="pdf-doc"> */}
            {/*     <div className="control"> */}
            {/*         <div className="zoom"> */}
            {/*             <button className="btn" onClick={() => setScale(s => s + .1)}>+</button> */}
            {/*             <button className="btn" onClick={() => setScale(s => s - .1)}>-</button> */}
            {/*             <span>{Math.floor(scale * 100)}%</span> */}
            {/*         </div> */}
            {/*     </div> */}
            {/*     {Array.from( new Array(numPages), (el, index) => ( */}
            {/*         <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={scale} className="pdf-page"/> */}
            {/*     ),)} */}
            {/* </Document> */}
            <iframe  className="pdf-doc" src={source} frameBorder="0"></iframe>
        </div>
    );
};
